export const pathUtils = {
    getParentPath: (path) => {
        const lastSlashIndex = path.lastIndexOf('/');
        return lastSlashIndex > 0 ? path.substring(0, lastSlashIndex) : '/';
    },

    getFileName: (path) => {
        const lastSlashIndex = path.lastIndexOf('/');
        return lastSlashIndex >= 0 ? path.substring(lastSlashIndex + 1) : path;
    },

    getExtension: (path) => {
        const fileName = pathUtils.getFileName(path);
        const parts = fileName.split('.');
        return parts.length > 1 ? parts.pop().toLowerCase() : '';
    },

    // These functions are kept for backward compatibility but simply return the input
    normalizePath: (path) => {
        console.warn('[DEPRECATED] normalizePath called - returning path unchanged');
        return path;
    },

    normalize: (path) => {
        console.warn('[DEPRECATED] normalize called - returning path unchanged');
        return path;
    },

    joinPaths: (...parts) => {
        console.warn('[DEPRECATED] joinPaths called - paths should be used directly from backend');
        return parts.filter(Boolean).join('/');
    },

    isSubPath: (parentPath, childPath) => {
        console.warn('[DEPRECATED] isSubPath called - paths should be compared as-is');
        return childPath.startsWith(parentPath);
    }
};